// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vxFakm2WiKVgEtAJ9ttFV"};